// extracted by mini-css-extract-plugin
export var navStyle = "navigation-module--navStyle--jnzTx";
export var navLink = "navigation-module--navLink--xLalQ";
export var activeLink = "navigation-module--activeLink--aLg76";